import { TargetLayer } from 'business/models/CustomModels';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { LayerDTO, ProteinLayerDTO, WellIngDTO } from 'business/models/Models';
import { LayerType } from 'utils/Global';
import {
  findWellsInLayer,
  createTargetLayer,
  updateDropByTargetLayer,
} from './GenerateCommon';
import { Compute } from './VolCalculator';

export function ProteinLayerGenerate(docData: ExperimentDtoClient, lyr: LayerDTO) {
  let proteinLayer: ProteinLayerDTO;
  if (lyr.type != LayerType.Protein) {
    throw new Error('ProteinLayerGenerate: Invalid Layer Type.');
  } else {
    proteinLayer = lyr.layerDetail as ProteinLayerDTO;
  }

  if (proteinLayer === undefined) {
    return;
  }

  if (
    proteinLayer.proteinLayerProteinFormulation === undefined ||
    proteinLayer.proteinLayerProteinFormulation.length == 0 ||
    proteinLayer.proteinLayerProteinFormulation[0].proteinFormulationId === undefined
  ) {
    return;
  }

  const plPf = proteinLayer.proteinLayerProteinFormulation[0];
  const layerWidth: number = lyr.width + 1;
  const layerHeight: number = lyr.height + 1;

  //ToDo : fix it?
  const wells: WellIngDTO[][] = findWellsInLayer(
    docData.plateDto,
    lyr,
    docData.containerRows,
    docData.containerCols,
  );

  for (let i = 0; i < layerHeight; i++) {
    for (let j = 0; j < layerWidth; j++) {
      const dropWellVolume: number = ComputeVaryAlong(
        lyr,
        i,
        j,
        plPf.startWellDropVolume,
        plPf.stopWellDropVolume,
        plPf.wellDropVolumeVaryAlong,
      );

      const dropProteinVolume: number = ComputeVaryAlong(
        lyr,
        i,
        j,
        plPf.startProteinDropVolume,
        plPf.stopProteinDropVolume,
        plPf.proteinDropVolumeVaryAlong,
      );

      const targetLayer: TargetLayer = createTargetLayer(lyr, wells[i][j]);
      targetLayer.volume = dropProteinVolume + dropWellVolume;
      targetLayer.waterVolume = 0;

      Compute(targetLayer, lyr, docData);

      const drop = updateDropByTargetLayer(lyr, targetLayer, wells[i][j]);
      drop.volume =
        Number(drop.volume.toFixed(3)) + Number(targetLayer.volume.toFixed(3));
      drop.waterVolume += targetLayer.waterVolume;
      drop.dropWellVolume = dropWellVolume;
      drop.dropProteinVolume = dropProteinVolume;
      //Todo--plPf.proteinFormulationId is not already set so always undefined. need to fix
      drop.proteinFormulationID = plPf.proteinFormulationId;
    }
  }
}

function ComputeVaryAlong(layer, wellRowIndex, wellColIndex, start, stop, varyAlong) {
  let layerRowWidth;
  let layerRowHeight;

  switch (varyAlong) {
    case 1: //None
      return start;
    case 2: //Row
      layerRowWidth = layer.width + 1;
      if (layerRowWidth == 1) {
        return start;
      }
      return start + ((stop - start) / (layerRowWidth - 1)) * wellColIndex;
    case 3: //Column
      layerRowHeight = layer.height + 1;
      if (layerRowHeight == 1) {
        return start;
      }
      return start + ((stop - start) / (layerRowHeight - 1)) * wellRowIndex;
    case 5: //Well Number
      layerRowWidth = layer.width + 1;
      layerRowHeight = layer.height + 1;
      if (layerRowHeight * layerRowWidth == 1) {
        return start;
      }
      return (
        start +
        ((stop - start) / (layerRowHeight * layerRowWidth - 1)) *
          (wellRowIndex * layerRowWidth + wellColIndex)
      );
    default:
      throw new Error('Unknown grid vary encountered.');
  }
}
